import { useEffect, useState, useContext } from "react";
import Search from "../assets/search_icon.svg";
import DrawerIcon from "../assets/svg/header/drawericon.svg";
import WhatsApp from "../assets/svg/header/whatsapp.svg";
import ShoppingCart from "../assets/svg/shopping_cart.svg";
import CompanyLogo from "../assets/header_logo.png";
import * as language from "../constants/languages";
import { getSupportData } from "../services/services";
import { AuthContext } from "../pages/RootPage";
import "../styles/HeaderRoot.css";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import Badge from "@mui/material/Badge";

export default function HeaderRoot({ opensnack }) {
  const navigate = useNavigate();
  const { toggleDrawer } = useContext(AuthContext);
  const [whatsAppNo, setwhatsAppNo] = useState("");
  const [supportNumber, setsupportNumber] = useState("");
  const [searchname, setsearchname] = useState("");
  const [logo, setlogo] = useState(CompanyLogo);
  const [badgeCount, setbadgeCount] = useState(0);

  useEffect(() => {
    getCompanyInfo();
    getSupportInfoData();
    getCartCount();
    window.addEventListener("productQtyChange", getCartCount);
    return () => {
      window.removeEventListener("productQtyChange", getCartCount);
    };
  }, []);

  const getCartCount = () => {
    const cart = localStorage.getItem("cartItems");
    if (!cart) {
      setbadgeCount(0);
    } else {
      const cartItems = JSON.parse(cart);
      setbadgeCount(cartItems?.customerCartItems?.length || 0);
    }
  };

  //get sotre name
  async function getCompanyInfo() {
    const value = localStorage.getItem("companyInfo");

    if (value === null || value === undefined) {
      setwhatsAppNo("");
    } else {
      let companyInfo = JSON.parse(value);
      const Logo = companyInfo.logo !== "" ? companyInfo.logo : CompanyLogo;
      setlogo(Logo);
      setwhatsAppNo(companyInfo.whatsAppNo);
    }
  }

  async function getSupportInfoData() {
    await getSupportData(language.companyidValue).then((supportData) => {
      if (supportData.status === "success") {
        setsupportNumber(supportData.data.contactNos);
      }
    });
  }

  async function openWhatsapp() {
    if (isMobile) {
      window.open("whatsapp://send?phone=" + whatsAppNo);
    } else {
      window.open(`https://web.whatsapp.com/send?phone=${whatsAppNo}`);
    }
  }

  async function callNow() {
    window.open(`tel:${supportNumber}`);
  }
  async function searchProduct() {
    if (searchname.trim().length == 0) {
      opensnack("Please enter a search term");
    } else {
      navigate(`/Search/${searchname}`);
    }
  }

  function keydown(e) {
    if (e.key === "Enter") {
      searchProduct();
    }
  }
  return (
    <div className="HeaderRoot">
      <div className="HeaderBg">
        <div className="drawerIconHeaderRoot">
          <img
            src={DrawerIcon}
            style={{ width: 20, height: 20 }}
            onClick={() => toggleDrawer()}
          />
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            cursor: "pointer",
            paddingInline: "8px",
          }}
          onClick={() => navigate("/")}
        >
          {logo && <img src={logo} height="auto" width={140} alt="Store Logo" style={{ cursor: "pointer", maxWidth: "100%", maxHeight: "40px", objectFit: "contain" }} />}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginRight: "10px" }}>
          <div
            style={{ cursor: "pointer", padding: "4px 8px", display: "flex", alignItems: "center" }}
            onClick={() => navigate("/Cart")}
            title="Cart"
          >
            <Badge badgeContent={badgeCount} color="warning">
              <img src={ShoppingCart} style={{ width: 26, height: 26 }} alt="Cart" />
            </Badge>
          </div>
          {whatsAppNo ? (
            <div
              style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}
              onClick={() => openWhatsapp()}
            >
              <img src={WhatsApp} style={{ width: 36, height: 36 }} alt="WhatsApp" />
            </div>
          ) : null}
          <div
            className={`CallNow ${supportNumber ? "d-flex" : "d-none"}`}
            onClick={() => callNow()}
            style={{ cursor: "pointer" }}
          >
            <p style={{ margin: 0, color: "#fff", fontSize: "13px" }}>Call Now</p>
          </div>
        </div>
      </div>
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: 12, paddingInline: 15 }}
      >
        <input
          type="text"
          placeholder={language.searchLabel}
          style={{ padding: 10, width: "70%" }}
          className="SearchField"
          autoCapitalize={"none"}
          onChange={(event) => setsearchname(event.target.value)}
          inputMode="search"
          onKeyDown={(e) => keydown(e)}
        />
        <div
          style={{
            backgroundColor: "#1d64b0",
            alignItems: "center",
            display: "flex",
            paddingInline: 15,
            paddingBlock: 5,
            borderRadius: 7,
          }}
        >
          <img src={Search} onClick={() => searchProduct()} />
        </div>
      </div>
    </div>
  );
}
